import React, { useEffect, useState } from 'react'
import { PollUtils } from '../../server/utils/poll-utils'
import { GeneralUtils } from '../../server/utils/general-utils'
import { ChoiceViewModel, PollChoiceViewModel } from 'models/poll-choice-viewmodel'
import rightMenuStyles from 'components/Layout/partials/RightMenu/RightMenu.module.scss'
import { Button } from 'components/_shared'
import styles from './PollCard.module.scss'

interface Props {
  poll: PollChoiceViewModel
  getPolls: () => void
}

const PollCard = ({poll, getPolls}: Props)  => {

  const [selectedChoice, setSelectedChoice] = useState<ChoiceViewModel>(null)
  const [votePlaced, setVotePlaced] = useState(false)

  const getData = async () => {
    await checkVotesByIP()
  }
  useEffect(() => {
    void getData()
  }, [])


  const handleVote = (selectedChoice: ChoiceViewModel) => {
    setSelectedChoice(selectedChoice)
  }

  const checkVotesByIP = async () => {
    if (poll.Id) {
      const result = await PollUtils.CheckVotesByIP(poll.Id)
      if (!result.isError) {
        if (result.data && result.data === true) {
          setVotePlaced(true)
        }
      } else {
        GeneralUtils.showError(result.message)
      }
    }
  }

  const placeVote = async () => {
    GeneralUtils.showHideLoadingDiv(true)
    const result = await PollUtils.Vote(selectedChoice)
    if (!result.isError && result.data) {
      setVotePlaced(true)
      setSelectedChoice(null)
      getPolls()
    }
    else {
      GeneralUtils.showError(result.message)
    }
    GeneralUtils.showHideLoadingDiv(false)
  }
  
  return (
    <>
      {
        poll &&
        <>
          <div className={rightMenuStyles.rightMenu__subheader}>{poll.Question}</div>
          {
            poll.PollChoices && poll.PollChoices.length > 0 &&
            poll.PollChoices.map((choice, i) => {
              return (
                <section key={i} className={rightMenuStyles.rightMenu__inputContainer}>
                  <div className="col p-0">
                    {!votePlaced && (
                      <input
                        type="radio"
                        className={rightMenuStyles.rightMenu__radio}
                        id={`quiz-${choice.Id}-${i + 1}`}
                        name="right-menu-quiz"
                        checked={selectedChoice == choice ? true : false}
                        onChange={e => {
                          handleVote(choice)
                        }}
                      />
                    )}

                    <label htmlFor={`quiz-${choice.Id}-${i + 1}`} className={votePlaced ? styles.rightMenu__label__voted : rightMenuStyles.rightMenu__label}>
                      {choice.Text ? choice.Text : null}
                    </label>
                    {votePlaced && (
                      <div className="progress">
                        <div className="progress-bar bg-info" role="progressbar" aria-valuenow={60} aria-valuemin={0} aria-valuemax={100} style={{ width: `${choice.VotePercent ? choice.VotePercent.toString() : 0}%` }}>{`${choice.VotePercent ? choice.VotePercent.toString() : 0}%`}</div>
                      </div>
                    )}

                  </div>
                </section>
              )
            })}
          {!votePlaced && (
            <Button 
              color="green"
              filled
              disabled={selectedChoice && selectedChoice.Text && selectedChoice.Text.length ? false : true}
              className={rightMenuStyles.rightMenu__button}
              onClick={() => {
                placeVote()
              }}
            >
              VOTE
            </Button>
          )}
        </>
      }
    </>
  )
}

export default PollCard
